import { render, staticRenderFns } from "./LunchMeal.vue?vue&type=template&id=7183b872&"
import script from "./LunchMeal.vue?vue&type=script&lang=js&"
export * from "./LunchMeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports